import client from "./client";

export const fetchMedia= async (id) =>{
    const response = await client.get("media/"+id, { _fields: 'source_url' })
    return response.data;

};